import React from 'react'
import './howItWorks.scss'
import HIW_Polygon from '../../../../assets/HIW_Polygon.png'
// import HOW_STEPS from '../../../../assets/HIW_STEPS.png'
import HOW_STEPS1 from '../../../../assets/HIW_STEPS1.svg'
// import VO_HOW_STEPS_MOBILE from '../../../../assets/VO_HOW_STEPS_MOBILE.png'
import VO_HOW_STEPS_MOBILE1 from '../../../../assets/VO_HOW_STEPS_MOBILE1.svg'
import Button from '../../../../components/button/Button'
import {useMediaQuery} from 'react-responsive'
import {useHistory} from 'react-router'

const HowItWorks = () => {
    const isMobile = useMediaQuery({maxWidth: 655})
    const history = useHistory()
    const pushPage = () => {
        history.push('/price-plan')
    }
    return (
        <div className="howItworks__section">
            <img className="howItworks__section__polygon" src={HIW_Polygon} alt=""/>
            <div className="howItworks__section__wrapper">
                <h1 className="howItworks__section__wrapper__heading primary__heading">Go
                    Global In Minutes</h1>
                <p>
                    Never miss another call with our team of Live Customer Service
                    Receptionists
                </p>
                {isMobile ? (
                    <img className="howItworks__section__wrapper__img"
                         src={VO_HOW_STEPS_MOBILE1} alt=""/>
                ) : (
                    <img className="howItworks__section__wrapper__img" src={HOW_STEPS1}
                         alt=""/>
                )}
                <div className="howItworks__section__wrapper__btn">
                    <Button text="Learn More" type="primary" onclick={pushPage}/>
                </div>
            </div>
        </div>
    )
}

export default HowItWorks
